<template>
  <section class="container mt-4">
    <br>
    <div class="mt-4" style="font-size: 20px; text-align:  center;" v-html="$t('exchange.ln_2')"></div>
    <br><br>
    <div class="text-center">
      <b-img class="img-circle" style="width: 81%;" src="../assets/img/logo.png" />
    </div>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('info.ln_4') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="4">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_13')"></div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_15')"></div>
            </b-card>
          </b-col>
          <b-col lg="4">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_14')"></div>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <hr>
    </template>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_1') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_2')"></div>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card no-body class="h-100" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <b-card-text style="border-color: transparent">
                <div class="text-center">
                  <b-img class="img-circle" style="width: 70%;" src="../assets/img/home/found.png" />
                </div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_3') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="3">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none ">
              <div class="text-center">
                <b-img class="img-circle" style="width: 100%; text-align: center; padding-bottom: 0px" src="../assets/img/home/tech_info.png" />
              </div>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_4')"></div>
            </b-card>
          </b-col>
          <b-col lg="3">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <div class="text-center">
                <b-row>
                  <b-col lg="12" style="border-color: transparent; background-color: transparent; box-shadow: none">
                    <b>{{ $t('home.data') }}</b>
                    <b-card style="font-size: 18px; border-color: transparent; background-color: transparent; box-shadow: none">
                      <b>{{ $t('explorer.ln_12') }}:</b> <a class style="color: #6e13ff"><b>{{ count | numberFormat }}</b></a>
                    </b-card>
                  </b-col >
                  <b-col lg="12" style="border-color: transparent; background-color: transparent; box-shadow: none">
                    <b-card style="font-size: 18px; border-color: transparent; background-color: transparent; ; box-shadow: none">
                      <b>EVC:</b> <a class style="color: #6e13ff"><b>{{ totalSupply | numberFormat }}</b></a>
                    </b-card>
                  </b-col>
                  <b-col lg="12" style="border-color: transparent; background-color: transparent; box-shadow: none">
                    <b-card style="font-size: 18px; border-color: transparent; background-color: transparent; box-shadow: none">
                      <b>TH/s:</b> <a class style="color: #6e13ff"><b>{{ Difficulty | numberFormat }}</b></a>
                    </b-card >
                  </b-col>
                  <b-col lg="12" style="border-color: transparent; background-color: transparent; box-shadow: none">
                    <b-card style="font-size: 18px; border-color: transparent; background-color: transparent; box-shadow: none">
                      <b>{{ $t('explorer.ln_10') }}:</b> <a class style="color: #6e13ff"><b>{{ peers }}</b></a>
                    </b-card >
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <hr>
    </template>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_5') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_6')"></div>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <div class="text-center">
                <b-img class="img-circle" style="width: 75%;" src="../assets/img/home/stage.png" />
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>



    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_10') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="12">
            <b-row>
              <b-col lg="4">
                <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
                  <div class="text-center" >
                    <a href="https://metamask.io/download.html" target="_blank"><b-img width="200%" src="../assets/img/home/Metamask.png" /></a>
                  </div>
                </b-card>
              </b-col>
              <b-col lg="4">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <div class="text-center">
                <a href="https://mycrypto.com/" target="_blank"><b-img width="250%" src="../assets/img/home/mycrypto.png" /></a>
              </div>
            </b-card>
              </b-col>
              <b-col lg="4">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <div class="text-center" >
                <a href="https://trezor.io/" target="_blank"><b-img width="200%" src="../assets/img/home/trezor.png" /></a>
              </div>
            </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="12" style="padding-top: 20px">
            <b-row>
              <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_11')"></div>
            </b-card>
              </b-col>
              <b-col lg="6">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <div class="container-fluid" v-html="$t('home.ln_12')"></div>
            </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('exchange.ln_5') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 10px">
        <b-row>
          <b-col lg="3">
            <b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://coinmarketcap.com/currencies/evrice/" target="_blank"><b-img width="190" style="text-align: center; margin-top: 10px" src="../assets/img/service/cmc.png"/></a>
            </b-card>
            <b-card class="text-center mb-4 " style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://www.coingecko.com/en/coins/evrice" target="_blank"><b-img width="190" style="text-align: center; line-height: normal" src="../assets/img/service/coingecko.png"/></a>
            </b-card>
          </b-col>
          <b-col lg="3">
            <b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://coincodex.com/crypto/evrice/" target="_blank"><b-img width="190" style="text-align: center" src="../assets/img/service/coincodex.png"/></a>
            </b-card>
            <b-card class="text-center mb-4" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://coincost.net/en/currency/evrice" target="_blank"><b-img width="190" style="text-align: center; " src="../assets/img/service/coincost.png"/></a>
            </b-card>

          </b-col>
          <b-col  lg="6">
            <b-card no-body class="mb-4" style="border-radius: 12px; border-color: transparent; box-shadow: none">
              <coingecko-coin-ticker-widget  coin-id="evrice" currency="usd" locale="en" width=""></coingecko-coin-ticker-widget>
            </b-card>
          </b-col>
        </b-row>
      </div>

    </template>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_7') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 10px">
        <b-row>
          <b-col lg="6">
            <b-card class="text-center mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://bitexbook.com/en/trading/evcbtc" target="_blank"><b-img width="250" style="text-align: center;" src="../assets/img/home/Bitexbook.png"/></a>
            </b-card>
          </b-col>
          <b-col lg="6">
            <b-card class="text-center mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a href="https://folgory.com/trade-crypto/EVC_BTC" target="_blank"><b-img width="250" style="text-align: center;" src="../assets/img/home/folgory.png"/></a>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_9') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 40px">
        <b-row>
          <b-col lg="12">
            <b-card no-body class="mb-4" style="border-color: transparent; background-color: transparent; font-size: 16px; box-shadow: none">
              <a class="twitter-timeline" data-height="700" style="font-size: 14px" data-theme="light" href="https://twitter.com/EvriceOfficial?ref_src=twsrc%5Etfw">Tweets by EvriceOfficial</a>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>

    <template>
      <h4 style="font-size: 26px; text-align:  center; padding-top: 60px"><b>{{ $t('home.ln_8') }}</b></h4>
    </template>
    <template>
      <div class="container my-4" style="padding-top: 10px">
        <b-row>
          <b-col lg="12">
            <b-card class="text-center mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
              <a target="_blank" href="https://t.me/evrice"><i style="color: DodgerBlue; font-size: 50px;" class="fab fa-telegram mr-4"></i></a> &nbsp;
              <a target="_blank" href="https://facebook.com/evriceofficial"><i style="color: SteelBlue; font-size: 50px;" class="fab fa-facebook mr-4"></i></a> &nbsp;
              <a target="_blank" href="https://medium.com/@EvriceOfficial"><i style="font-size: 50px;" class="fab fa-medium-m mr-4"></i></a> &nbsp;
              <a target="_blank" href="https://bitcointalk.org/index.php?topic=5323219"><i style="color: goldenrod; font-size: 50px;" class="fab fa-bitcoin mr-4"></i></a> &nbsp;
              <a target="_blank" href="https://twitter.com/EvriceOfficial"><i style="color: DodgerBlue; font-size: 50px;" class="fab fa-twitter mr-4"></i></a> &nbsp;
              <a target="_blank" href="https://github.com/EVRICE"><i style="font-size: 50px;" class="fab fa-github mr-4"></i></a>
              <a target="_blank" href="https://www.reddit.com/r/Evrice/"><i style="font-size: 50px; color: #FF4500" class="fab fa-reddit mr-4"></i></a>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </template>
    <hr>

    <template>
      <h4 style="font-size: 18px; text-align:  center; padding-top: 10px">© Evrice 2020 - 2025</h4>
    </template>
    <div id="script_block" class="script_block"></div>
  </section>
</template>

<script>
  import axios from "axios";
  import api from '../libs/api';

  export default {

    name: "index.main",

    data() {
      return {
        count: 0,
        hashrate: 0,
        peers: 0,
        timeBlock: 0,
        finder: null,
        innerPeer: 2,
        syncing: false,
        totalSupply: 0,
        Difficulty: 0,
      }
    },
    metaInfo () {
      return {
        title: 'Evrice Crypto Network'
      }
    },
    mounted() {
      this.getStatistic();
      this.GetTotalSupply();
      this.GetDifficulty ();
      this.getPeers();
    },
    methods: {
      getStatistic() {
        this.$web3.eth.getBlockNumber().then(async (number) => {
          this.$data.count = number;

          // New block header.
          this.$web3.eth.subscribe('newBlockHeaders', (error, blockHeader) => {
            if (error) return this.$log.info(error);

            if (this.$data.count !== blockHeader.number) {
              this.GetTotalSupply();
              this.GetDifficulty();
            }

            this.$data.count = blockHeader.number;

          });

        });
      },
      GetTotalSupply () {
        axios.get(api.explorer.getTotalsupply).then((response) => {
          this.$data.totalSupply = response.data.totalsupply;
        });
      },
      GetDifficulty () {
        axios.get(api.explorer.getDifficulty).then((response) => {
          this.$data.Difficulty = response.data.difficulty;
        });
      },
      getPeers() {
        this.$web3.eth.net.getPeerCount().then((peer) => {
          if (peer === 0) {
            this.$data.peers = this.$data.innerPeer;
          } else {
            this.$data.peers = peer + this.$data.innerPeer;
          }
        });
      }
    }
  }

</script>